<template>
  <ol class="ml-7 list-decimal">
    <slot />
  </ol>
</template>
